import type { Locale } from './logo'

/**
 * Shaffof ID ga tegishli matnlarning yagona ko'rinishi.
 *
 * Nega SDK ichida: hozir har bir tizim «JSHSHIR» ni o'zicha nomlaydi
 * («PINFL», «shaxsiy raqam», «ЖШШИР»), rozilik ro'yxatini esa o'z so'zi
 * bilan yozadi. Fuqaro uchun bu har safar boshqa xizmatdek ko'rinadi.
 * Matnlar bitta joydan kelsa — hamma joyda bir xil bo'ladi.
 */

/** `scope` identifikatori -> odam o'qiydigan tavsif */
const SCOPES: Record<Locale, Record<string, string>> = {
  uz: {
    openid: 'Shaxsni tasdiqlash',
    profile: 'F.I.Sh, tug\'ilgan sana, jins',
    email: 'Elektron pochta manzili',
    phone: 'Telefon raqami',
    pinfl: 'JSHSHIR',
    passport: 'Pasport seriya va raqami',
    organization: 'Tashkilot ma\'lumotlari (STIR, nomi, lavozimi)',
    eimzo: 'E-IMZO sertifikati ma\'lumotlari',
    roles: 'Shu tizimdagi rollaringiz',
    documents: 'Hujjat imzolashga yuborish',
    offline_access: 'Uzoq muddatli kirish (siz yo\'qligingizda ham)',
  },
  ru: {
    openid: 'Подтверждение личности',
    profile: 'Ф.И.О., дата рождения, пол',
    email: 'Электронная почта',
    phone: 'Номер телефона',
    pinfl: 'ПИНФЛ',
    passport: 'Серия и номер паспорта',
    organization: 'Данные организации (ИНН, название, должность)',
    eimzo: 'Данные сертификата E-IMZO',
    roles: 'Ваши роли в этой системе',
    documents: 'Отправка документов на подпись',
    offline_access: 'Долгосрочный доступ (в том числе без вас)',
  },
  en: {
    openid: 'Identity verification',
    profile: 'Full name, date of birth, gender',
    email: 'Email address',
    phone: 'Phone number',
    pinfl: 'Personal number (PINFL)',
    passport: 'Passport series and number',
    organization: 'Organisation details (TIN, name, position)',
    eimzo: 'E-IMZO certificate details',
    roles: 'Your roles in this system',
    documents: 'Sending documents for signing',
    offline_access: 'Long-term access (even when you are away)',
  },
}

export const UI_TEXT = {
  uz: {
    individual: 'Jismoniy shaxs',
    legal: 'nomidan',
    tin: 'STIR',
    scopesTitle: 'Bu tizim quyidagi ma\'lumotlaringizni oladi',
    required: 'majburiy',
    signedBy: 'Imzoladi',
    signedAt: 'Sana',
    method: { eimzo: 'E-IMZO elektron raqamli imzo', face: 'Yuzni tasdiqlash' },
    bodyHash: 'Hujjat hash (SHA-256)',
    signatureHash: 'Imzo hash',
    verify: 'Imzoni tekshirish',
    receiptNote: 'Hash\'lar qo\'lingizdagi nusxadagisi bilan bir xil bo\'lishi kerak.',
  },
  ru: {
    individual: 'Физическое лицо',
    legal: 'от имени',
    tin: 'ИНН',
    scopesTitle: 'Эта система получит следующие ваши данные',
    required: 'обязательно',
    signedBy: 'Подписал',
    signedAt: 'Дата',
    method: { eimzo: 'ЭЦП E-IMZO', face: 'Подтверждение по лицу' },
    bodyHash: 'Хеш документа (SHA-256)',
    signatureHash: 'Хеш подписи',
    verify: 'Проверить подпись',
    receiptNote: 'Хеши должны совпадать с вашей копией.',
  },
  en: {
    individual: 'Individual',
    legal: 'on behalf of',
    tin: 'TIN',
    scopesTitle: 'This system will receive the following data',
    required: 'required',
    signedBy: 'Signed by',
    signedAt: 'Date',
    method: { eimzo: 'E-IMZO digital signature', face: 'Face verification' },
    bodyHash: 'Document hash (SHA-256)',
    signatureHash: 'Signature hash',
    verify: 'Verify the signature',
    receiptNote: 'The hashes must match the copy you hold.',
  },
} as const

/** Noma'lum scope ham ro'yxatda ko'rinsin — identifikatorining o'zi bilan */
export function scopeLabel(scope: string, locale: Locale = 'uz'): string {
  return SCOPES[locale][scope] ?? scope
}

export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join('')
}
